import React from "react";
import { Typography, Box } from "@mui/material";
import { InfoFieldProps } from "./types";

/**
 * InfoField displays a label-value pair with an icon in a styled container.
 * Used to show metadata fields in a consistent, visually appealing format.
 */
const InfoField: React.FC<InfoFieldProps> = ({ label, value, icon }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      py: 1,
      borderRadius: 1,
      borderColor: "divider",
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "primary.main",
        opacity: 0.7,
      }}
    >
      {React.cloneElement(icon, { sx: { fontSize: 18 } })}
    </Box>
    <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ fontSize: "0.75rem", fontWeight: 500 }}
      >
        {label}:
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, fontSize: "0.875rem" }}
      >
        {value}
      </Typography>
    </Box>
  </Box>
);

export default InfoField;
